import styled, { css } from 'styled-components';
import Card from 'components/Card';
import UserAvatar from 'components/UserAvatar';
import ListTile from 'components/ListTile';
import { Customer } from 'data/firestore/agent/customer/types';
import {
    GREY_100,
    GREY_300,
    GREY_400,
    GREY_800,
    RED_500,
    RED_700,
    WHITE,
} from '../../../../constants';

export const TodosViewContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    padding: 0 1.25rem 1.25rem;
`;

export const FiltersSidebar = styled.div`
    width: 21.25rem;
    min-width: 21.25rem;
    border: none;
    border-radius: 0;
    background: transparent;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const CardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0.875rem;
`;

export const CardsScrollContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const OverdueAlertBanner = styled.button`
    width: 100%;
    min-height: 2rem;
    border: none;
    border-radius: 0.5rem;
    background: ${RED_500};
    color: ${WHITE};
    font-size: 0.8125rem;
    font-weight: 700;
    line-height: 1.1rem;
    letter-spacing: 0.01em;
    padding: 0.4rem 0.75rem;
    text-align: left;
    cursor: pointer;
    position: relative;
    z-index: 2;
    box-shadow: 0 4px 12px rgba(122, 17, 37, 0.24);

    &:hover {
        background: ${RED_700};
    }

    &:focus-visible {
        outline: 2px solid ${WHITE};
        outline-offset: 1px;
    }
`;

export const OpportunityTodoCard = styled(Card)`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    flex-shrink: 0;
    padding: 1rem;
    border-radius: 1rem;
    background: ${WHITE};
    border: 1px solid ${GREY_100};
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06);
`;

export const OpportunityHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    border-bottom: 1px solid ${GREY_100};
    padding-bottom: 0.75rem;
`;

export const HeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
`;

export const CustomerName = styled.button`
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5rem;
    text-align: left;
    padding: 0;
    margin: 0;
    color: ${GREY_400};
    background: none;
    border: none;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;

export const OpportunityTitleButton = styled.button`
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    color: ${GREY_800};
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.25rem;
    text-align: left;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;

export const MetaText = styled.span`
    color: ${GREY_400};
    font-size: 0.8125rem;
    line-height: 1.25rem;
`;

export const CustomerNameButton = styled.button`
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    color: ${GREY_400};
    font-size: 0.8125rem;
    line-height: 1.25rem;
    text-align: left;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;

export const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    flex-wrap: wrap;
`;

export const HeaderTiles = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
`;

export const CustomerAvatar = styled(UserAvatar)<{ channel?: Customer['channel'] }>`
    border: 4px solid #7367F0;
    flex-shrink: 0;

    svg {
        width: 2.5rem;
        height: 2.5rem;
    }

    ${(props) => props.channel === 'facebook' && css`
        border-color: #1877F2;
    `};

    ${(props) => props.channel === 'instagram' && css`
        border-color: #DD2A7B;
    `};

    ${(props) => props.channel === 'whatsapp' && css`
        border-color: #25D366;
    `};

    ${(props) => props.channel === 'tiktok' && css`
        border-color: #000000;
    `};

    ${(props) => props.channel === 'telegram' && css`
        border-color: #24A1DE;
    `};

    ${(props) => props.channel === 'widget_chatbot' && css`
        border-color: #2E2960;
    `};
`;

export const OwnerAvatar = styled(UserAvatar)`
    width: 1.25rem;
    height: 1.25rem;

    svg {
        width: 0.875rem;
        height: 0.875rem;
    }

    & abbr {
        font-size: 0.7rem;
    }
`;

export const OwnerTile = styled(ListTile)`
    & > div ~ div > span {
        color: ${GREY_400};
        font-size: 0.8125rem;
    }
`;

export const TodosListContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const EmptyState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    color: ${GREY_400};
    border: 1px dashed ${GREY_300};
    border-radius: 0.75rem;
`;
